export enum EPaymentMethodType {
  Card = "card",
  PayPal = "paypal",
}
